export const notificacoes = (state) => {
  return state.notificacoes || []
}

export const qtdNotRead = (state) => {
  return state.qtdNotRead || 0
}

export const loading = (state) => {
  return state.loading
}
